import { FC, memo } from "react";
import useDynamicFilters from "./view/useDynamicFilters";

interface IDynamicFilters {
  filterStructure: any[];
  filterValues: any;
  onSetFilters: (key: string, value: any) => void;
  isModal?: boolean;
  onApplyFilters?: (() => void) | undefined;
}
const DynamicFilters: FC<IDynamicFilters> = ({
  filterStructure,
  onSetFilters,
  filterValues,
  isModal,
  onApplyFilters,
}) => {
  const { fieldTypes } = useDynamicFilters({
    onApplyFilters,
    filterValues,
    filterStructure,
  });
  return (
    <div
      className={`grid ${isModal ? "grid-cols-3" : "grid-cols-4"
        } gap-4 mb-4 flex-1`}
    >
      {filterStructure.map((item: any) => (
        <div key={item.key}>
          {fieldTypes[item.type]({
            values: filterValues?.[item.key],
            handleChange: onSetFilters,
            data: item,
          })}
        </div>
      ))}
    </div>
  );
};

export default memo(DynamicFilters);
